import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B06SupplierPage } from '../b06-supplier/b06-supplier';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B06aSupplierInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface typeInfo{
  SUPPLIER_TYPE_ID: number;
  TYPE: string;
}

interface statusInfo{
  SUPPLIER_STATUS_ID: number;
  STATUS: string;
}

@IonicPage()
@Component({
  selector: 'page-b06a-supplier-info',
  templateUrl: 'b06a-supplier-info.html',
})
export class B06aSupplierInfoPage {
  private todo : FormGroup;
  loading: any;
  Status: any;
  typeArr: typeInfo[] = [];
  typeItems: typeInfo[] = [];
  statusArr: statusInfo[] = [];
  statusItems: statusInfo[] = [];

  supplierData = {  SUPPLIER_CODE:'', SUPPLIER_NAME:'', 
                    ADDR1:'', ADDR2:'', ADDR3:'', 
                    CONTACT_NO:'', EMAIL:'',
                    SUPPLIER_TYPE_ID:'', SUPPLIER_STATUS_ID:'',
  }
  SUPPLIER_ID:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      supplierCode: ['', Validators.required],
      supplierName: ['', Validators.required],
      address: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      type: ['', Validators.required],
      status: ['', Validators.required],
    });

    this.SUPPLIER_ID = this.navParams.get('paramID');    //card ID

    let tbl = ["SUPPLIER"];
    let column = ["SUPPLIER_ID"];
    let value = [this.SUPPLIER_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"SUPPLIER","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
//        this.loading.dismiss();

        let Records = result["Records"];
        this.supplierData.SUPPLIER_CODE = Records[0]["SUPPLIER_CODE"];
        this.supplierData.SUPPLIER_NAME = Records[0]["SUPPLIER_NAME"];
        this.supplierData.ADDR1 = Records[0]["ADDR1"];
        this.supplierData.ADDR2 = Records[0]["ADDR2"];
        this.supplierData.ADDR3 = Records[0]["ADDR3"];
        this.supplierData.CONTACT_NO = Records[0]["CONTACT_NO"];
        this.supplierData.EMAIL = Records[0]["EMAIL"];
        this.supplierData.SUPPLIER_TYPE_ID = Records[0]["SUPPLIER_TYPE_ID"];
        this.supplierData.SUPPLIER_STATUS_ID = Records[0]["SUPPLIER_STATUS_ID"];

        //get type data and status data
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
//        this.showLoader();

        this.serviceapi.readdata(json_data,"SUPPLIER_TYPE","1","1").then((result) => {
          
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.typeArr = Records;
            this.typeItems = this.typeArr;

            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];
          
            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");

            this.serviceapi.readdata(json_data,"SUPPLIER_STATUS","1","1").then((result) => {
              this.loading.dismiss();
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.statusArr = Records;
                this.statusItems = this.statusArr;
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
            });
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B06aSupplierInfoPage');
  }

  delete(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to delete this supplier? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
            this.serviceapi.deletedata('SUPPLIER', 'SUPPLIER_ID', this.SUPPLIER_ID).then((result) => {
          
              this.Status = result["Message"];
              if (this.Status == "1"){
                this.loading.dismiss();
                this.navCtrl.setRoot(B06SupplierPage);
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
            });
        
          }
        }
      ]
    });
    confirm.present();
  }

  update(){
    this.showLoader();
    this.serviceapi.updatedata('SUPPLIER', 'SUPPLIER_ID', this.SUPPLIER_ID, this.supplierData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B06SupplierPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
    
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B06SupplierPage)
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b06a-supplier-info/b06a-supplier-info.ts